<template>
    <div>
        <div class="comment">
            <div class="comment1"> 
                <Icon @click="like" type="md-heart" class="icon-heart" :style="obj"/>
                <span @click="like" v-show="likes === 0" style="cursor: pointer; margin-left: 4px;">赞</span> 
                <span v-show="likes !== 0" style="padding-left: 10px;">{{ likes }}</span>
            </div>
            <div class="comment2"> 
                <i @click="clickMeToShow(item.id)" class="el-icon-s-comment" style="cursor: pointer;margin-top: 2px; font-size: 24px;"></i>
                <span @click="clickMeToShow(item.id)" style="cursor: pointer;  margin-left: 4px;">评论</span> 
            </div>
            <!-- <div class="comment3">收藏(暂不可用)</div> -->
        </div>
        <div v-if="flag === item.id" style="margin-top: 20px;"> <!-- 写回复评论 -->

            <mavon-editor :boxShadow="false" :codeStyle="codeStyle" :toolbars="toolbars" :tabSize="tabSize" v-model="content" 
            :ishljs="true" ref="md" @change="change" style="margin-left: 18px; min-height:250px; max-height: 250px;"/>

            <div style="text-align: right; padding-right: 40px; padding-top: px;">
                <span style="color: #869394; cursor: pointer; font-size: 14px;" @click="CreateReply">提交评论</span>
            </div>
        </div>

        <div class="body" v-if="res === item.id" v-for="l in list" :key="l.id" >
            <div class="body-content" @mouseover="showText = l.id" @mouseleave="showText = 0">
                <div style="height: auto; width: 30px; padding-left: 10px;">
                    <img :src="l.photo" style=" border-radius: 50%; margin-top: 5px;" width="30px" height="30px" alt="你的头像">
                </div>
                <div style="margin-left: 17px; height: auto;"> 
                    <p style="font-size: 13px; color: orange; margin-top: 5px; ">{{ l.userName }} 
                        <span style="color: #909399; margin-left: 5px;">{{ l.createTime }}</span>
                        <span @click="deleteReply(l.id)" v-if="showText == l.id && l.userId == $store.state.me.id" style="margin-left: 10px; color: #25BB9B; cursor: pointer;">删除</span>
                    </p>
                    <mavon-editor slot="reference" class="markdown-body" :boxShadow="false" style="min-width: 827px; max-width: 827px; background-color: #F2F2F2;
                    min-height: 10px;" codeStyle="monokai" v-html="l.content"></mavon-editor>
                    <div style="cursor: pointer; width: 830px;font-size: 14px;">
                        <span v-if="l.otherName !== 'null'" style="font-size: 14px; color: #909399;">
                            回复 @{{ l.otherName }}
                        </span>
                        <span v-if="ans == 0" style="float: right; padding-right: 10px; color: #25BB9B;" @click="ans = l.id">回复</span>
                        <span v-if="ans == l.id" style="float: right; padding-right: 10px; color: #25BB9B;" @click="ans = 0">收回</span>

                        <mavon-editor v-if="ans == l.id" :boxShadow="false" :codeStyle="codeStyle" :toolbars="toolbars" :tabSize="tabSize" 
                        v-model="reply" 
                        :ishljs="true" ref="md" @change="change1" style="margin-top: 20px; width: 800px; min-height:250px; max-height: 250px;"/>
                        <span v-if="ans == l.id" style="color: #909399; padding-bottom: 10px; padding-top: 4px; padding-right: 20px; 
                        float: right; cursor: pointer;" @click="replylll(l)">提交评论</span>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';

    export default {
        props:["item"],
        data() {
            return {
                visible: false,
                res: 0,
                flag: 0,
                ans: 0,
                error_message:'',

                list:[],
                showText: 0,

                content: "",
                tabSize:4,
                page_article:undefined,
                html_content:undefined,
                md_content:undefined,
                toolbars: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: true, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: true, // 保存（触发events中的save事件）
                    navigation: true, // 导航目录
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    subfield: true, // 单双栏模式
                    preview: true // 预览
                },
                codeStyle:'monokai-sublime',//主题
                test_html:undefined,

                reply:'',
                markdown: undefined,
                
                isExit: false, // 说明没点过赞
                likes: 0,
                status: 0, // 表示点赞状态
                valuev:{},
                obj: {
                    color: "",
                }
            }
        },
        mounted() {
            this.likes = this.item.likes
            this.ReadReply()
            this.ReadLike()
        },
        methods: {
            like() {
                if (!this.$store.state.me.is_login) {
                    this.$notify({
                    title: '通知：',
                    message: '请先登录',
                    });
                    return ;
                }
                if (!this.isExit) { // 说明这次是点赞
                    const vue = this
                    const store = this.$store
                    $.ajax({
                        url: Url.cLikeMessageUrl,
                        type:'post',
                        headers: {
                            Authorization: "Bearer " + store.state.me.token,
                        },
                        data: {
                            messageId: vue.item.id,
                            userId: store.state.me.id,
                        },
                        success(resp) {
                            if (resp.error_message === "success") {
                                console.log("点赞成功咯")
                                vue.ReadLike()
                                vue.isExit = true
                                vue.likes ++ ;
                                vue.status = 1; // 刚点完赞那么状态肯定是1
                                vue.obj.color = "read"
                            }
                        }
                    })
                } else { // 说明点过赞 直接修改就行了
                    const vue = this
                    const store = this.$store
                    $.ajax({
                        url: Url.uLikeMessageUrl,
                        type:'post',
                        headers: {
                            Authorization: "Bearer " + store.state.me.token,
                        },
                        data: {
                            id: vue.valuev.id
                        },
                        success(resp) {
                            if (resp.error_message === "success") {
                                if (resp.message === "点赞成功") {
                                    vue.likes ++ ;
                                    vue.status = 1; // 刚点完赞那么状态肯定是1
                                    vue.obj.color = "red"
                                } 
                                if (resp.message === "取消点赞成功") {
                                    vue.likes -- ;
                                    vue.status = 0; // 刚点完赞那么状态肯定是1
                                    vue.obj.color = ""
                                }
                            }
                        }
                    })
                }
            },
            ReadLike() {
                const vue = this
                const store = this.$store
                $.ajax({
                    url: Url.rLikeMessageUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        messageId: vue.item.id,
                        userId: store.state.me.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.isExit = true // 说明点过赞
                            vue.status = parseInt(JSON.parse(resp.value).status);
                            vue.valuev = JSON.parse(resp.value)

                            if (vue.status === 1) {
                                vue.obj.color = "red"
                            } else {
                                vue.obj.color = ""
                            }
                        } 
                    }
                })
            },
            change(value, render){
                this.test_html = render;
            },
            change1(value, render){
                this.markdown = render;
            },
            clickMeToShow(id) {
                this.flag = this.flag == 0 ? id : 0
                this.res = this.res == 0 ? id : 0
            },
            deleteReply(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.dReplyMessageUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                        }
                    }
                })
            },
            CreateReply() {
                if (!this.$store.state.me.is_login) {
                    this.$notify({
                    title: '通知：',
                    message: '请先登录',
                    });
                    return ;
                }
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.cReplyMessageUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        otherId: 0, // 这个是回复主贴的 那么就是0
                        otherName: "null",
                        photo: store.state.me.photo,
                        content: vue.test_html,
                        markdown: vue.content,
                        messageId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                            vue.content = ''
                        } else {
                            vue.$notify.error({
                                title: 'error',
                                message: resp.error_message,
                                position: 'bottom-right'
                            });
                        }
                    }
                })
            },
            ReadReply() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.rReplyMessageUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        messageId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                        } else {
                            vue.list = []
                        }
                    }
                })
            },
            replylll(item) {
                if (!this.$store.state.me.is_login) {
                    this.$notify({
                    title: '通知：',
                    message: '请先登录',
                    });
                    return ;
                }
                const vue = this
                const store = this.$store

                // console.log(" == ", this.markdown)

                $.ajax({
                    url: Url.cReplyMessageUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        otherId: item.userId, // 这个是回复主贴的 那么就是0
                        otherName: item.userName,
                        photo: store.state.me.photo,
                        content: vue.markdown,
                        markdown: vue.reply,
                        messageId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                            vue.ans = 0
                            vue.reply = ''
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.icon-heart {
    margin-top: 4px;
    cursor: pointer; 
    font-size: 20px;
}
.comment1{
    justify-content: center;
    width: 33%;
    /* margin-left: 30px; */
    font-size:18px;
    display: flex;
}
.comment2{
    justify-content: right;
    margin-right: 100px;
    width: 66%;
    /* margin-left: 300px; */
    font-size:18px;
    display: flex;
}
.comment{
    font-size:18px;
    display: flex;
    padding: 2px;
}
.body {
    margin-top: 6px;
    width: 900px;
    height: auto;
    margin-bottom: 10px;
}
.body-content {
    display: flex;
    float: left;
    width: 875px;
    background-color: #F2F2F2;
    padding-block: 4px;
}
</style>